<template>
    <div :class="{'hidden':hidden}" class="pagination-container">
        <!--分页区域-->
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                :layout="layout"
                :total="total">
        </el-pagination>
    </div>
</template>

<script>
export default {
    name: '',
    props: {
        total: {
            required: true,
            type: Number
        },
        page: {
            type: Number,
            default: 1
        },
        limit: {
            type: Number,
            default: 20
        },
        pageSizes: {
            type: Array,
            default() {
                return [10, 20, 30, 50]
            }
        },
        layout: {
            type: String,
            default: 'total, sizes, prev, pager, next, jumper'
        },
        hidden: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        currentPage: {
            get() {
                return this.page
            },
            set(val) {
                this.$emit('updatePage', val)
            }
        },
        pageSize: {
            get() {
                return this.limit
            },
            set(val) {
                console.log("触发了。。。" + val)
                this.$emit('updateLimit', val)
            }
        }
    },
    methods: {
        handleSizeChange(val) {
            // 触发页切换事件，对应父组件的事件名为pagination
            /*this.$emit('pagination', { page: this.currentPage, limit: val })
            if (this.autoScroll) {
                scrollTo(0, 800)
            }*/
            console.log("methods触发了。。。" + val)
            this.$emit('updateLimit', val)
        },
        handleCurrentChange(val) {
            /*this.$emit('pagination', { page: val, limit: this.pageSize })
            if (this.autoScroll) {
                scrollTo(0, 800)
            }*/
            console.log("methods触发了。。。" + val)
            this.$emit('updatePage', val)
        }
    }
}
</script>

<style scoped>
.pagination-container.hidden {
    display: none;
}
</style>
